export const ViewMode = {
  Default: "default",
  Wide: "wide",
  Flyout: "flyout",
};
export const FlyoutTileID = "flyout";
export const RadialGradientIconId = "icon-radial-gradient";
export const AppBarDefaultValue = 48;
export const AppBarMercuryValue = 48;
export const TileDimensionDefaultValue = 40;
export const SelectionBarDefaultValue = 32;
export const AppBarWideValue = 68;
export const TileHeightWideValue = 56;
export const TileHeightMercuryValue = 48;
export const TileWidthMercuryValue = 48;
export const SelectionBarWideValue = 48;
export const AppBarVisualRefreshTopMargin = 48;
export const TileHeightVisualRefreshValue = 64;
export const AppBarBottomMargin = TileDimensionDefaultValue;

//RockSteadyExperience
export const AppBarRockSteadyTopMargin = 56;
export const AppBarRockSteadyTopMarginPwa = 0;
export const AppBarRockSteadyTileHeight = 64;
export const AppBarRockSteadyBottomMargin = 104;

export const AppBarDividerMaxHeightValue = 4;
export const AppFlyoutMaxHeight = 484 + "px";
export const AppFlyoutMinHeight = 376 + "px";
export const AppFlyoutSmallMinHeight = 282 + "px";
export const AppFlyoutSmallMaxHeight = 376 + "px";
export const AppFlyoutNoFooterHeight = 441 + "px";
export const AppFlyoutNoFooterMinHeight = 282 + "px";
export const AppFlyoutWidth = 340 + "px";
export const AppFlyoutFlexContainerHeight = "100%";
export const AppFlyoutFlexContainerWidth = "100%";
export const FlyoutIconSize = 28 + "px";
export const FlyoutTileHeight = "104px";
export const FlyoutTileWidth = "100px";
export const FlyoutTileIconSize = "48px";
export const FlyoutFooterHeight = "64px";
export const FlyoutFooterMinHeight = "40px";
export const FlyoutTileContainerHeight = "401px";
export const FlyoutTileContainerMaxHeightWithSearch = "370px";
export const FlyoutTileContainerWidth = "95%";
export const FlyoutTileContainerTopMargin = "16px";
export const FlyoutTileContainerLeftPadding = "1px";
export const FlyoutTilesGap = "2px";
export const FlyoutFlexContainerWidth = "90%";
export const FlyoutDividerHeight = "1px";
export const FlyoutFooterDividerWidth = "90%";
export const FlyoutResultsDividerWidth = "284px";
export const FlyoutScrollBarHeight = "40px";
export const FlyoutScrollBarWidth = "6px";
export const FlyoutScrollBarThumbBorderRadius = "4px";
export const AppBarDefault = AppBarDefaultValue + "px";
export const AppBarMercury = AppBarMercuryValue + "px";
export const AppBarWide = AppBarWideValue + "px";
export const SelectionBarDefault = SelectionBarDefaultValue + "px";
export const SelectionBarWide = SelectionBarWideValue + "px";
export const TileDimensionDefault = TileDimensionDefaultValue + "px";
export const TileHeightWide = TileHeightWideValue + "px";
export const TileHeightMercury = TileHeightMercuryValue + "px";
export const TileWidthMercury = TileWidthMercuryValue + "px";
export const BadgeSize = "16px";
export const TileMarginDefaultValue = 3;
export const TileMarginDefault = TileMarginDefaultValue + "px";
export const SelectionBarMarginTopDefault =
  (TileDimensionDefaultValue - SelectionBarDefaultValue) / 2 +
  TileMarginDefaultValue;
export const SelectionBarMarginTopWide =
  (TileHeightWideValue - SelectionBarWideValue) / 2;
export const MinTiles = 1; // Minimum number of non-hoisted, non-flyout button tiles to enforce
export const AppBarMinHeight =
  MinTiles * (TileDimensionDefaultValue + 2 * TileMarginDefaultValue) + "px";
export const AppBarMinHeightWide = MinTiles * TileHeightWideValue + "px";
export const TileIconSizeDefault = "20px";
export const TileOutlineIconSizeWide = "20px";
export const TileIconSizeWide = "24px";
export const TileIconSizeMercury = "24px";
export const AppBarDividerMaxHeight = AppBarDividerMaxHeightValue + "px";
/**
 * Media Queries
 **/
// Max Width 320px
export const AppFlyoutHeightMaxWidth400 = "250px";
export const AppFlyoutWidthMaxWidth400 = "250px";
export const MessageExtensionsAppFlyoutHeightMaxWidth320 = "250px";
export const MessageExtensionsAppFlyoutWidthMaxWidth320 = "250px";
export const FlyoutTileHeightMaxWidth480 = "92px";
export const FlyoutTileWidthMaxWidth480 = "75px";
export const OutlineIconFilterID = "appbar-outline-icon-filter";
export const FlyoutSearchBoxID = "flyout-search-box";
// DND Constants
export const DND_MINIMUM_ACTIVATION_DISTANCE_Y_AXIS_PX = 2;
export const DND_TOUCH_SENSOR_TOLERANCE_PX = 10;
export const DND_TOUCH_SENSOR_DELAY_MS = 250;
export const TeamsTokens = {
  colorTeamsButtonCompositeHoverShadow1:
    "var(--colorTeamsButtonCompositeHoverShadow1)",
  colorTeamsButtonCompositeHoverShadow2:
    "var(--colorTeamsButtonCompositeHoverShadow2)",
  colorTeamsButtonCompositeHoverShadow3:
    "var(--colorTeamsButtonCompositeHoverShadow3)",
  colorTeamsButtonCompositeHoverShadow4:
    "var(--colorTeamsButtonCompositeHoverShadow4)",
  colorTeamsButtonCompositeFocusShadow1:
    "var(--colorTeamsButtonCompositeFocusShadow1)",
  colorTeamsButtonCompositeFocusShadow2:
    "var(--colorTeamsButtonCompositeFocusShadow2)",
  colorTeamsButtonCompositeFocusShadow3:
    "var(--colorTeamsButtonCompositeFocusShadow3)",
  colorTeamsButtonCompositeFocusShadow4:
    "var(--colorTeamsButtonCompositeFocusShadow4)",
};
//Visual refresh (office) constants
export const VisualRefresh = {
  tileMinWidth: "52px",
  tileMaxWidth: "52px",
  tileMinHeight: "48px",
  tileWidth: "52px",
  tileHeight: "48px",
  tileMarginTop: "8px",
  tileBorderRadius: "12px",
  tileContainerWidth: "68px",
  tileContainerHeight: "56px",
  radialGradientColor:
    "radial-gradient(211.91% 201.79% at 110% -22.5%, #4750EB 36.72%, #D660FF 97.5%)",
  iconGradientTransform:
    "translate(22.8 -2.27136) rotate(130.457) scale(37.4496 39.0081)",
  gradientStartColor: "#4750EB",
  gradientEndColor: "#D660FF",
};
